module.exports = __webpack_public_path__ + "static/don37-dc19c192d5ddb3bbf82a1a770e73d4ea.jpg";